<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Your Access Passes</h4>
          </md-card-header>
          <md-card-content>
            <div v-if="user.passes.length === 0" class="py-2">
              <span class="d-block">You don't have any passes.</span>
            </div>
            <div v-for="(pass, id) in user.passes" :key="id" class="row g-4">
              <div
                class="col-3 col-sm-2 py-3 d-flex justify-content-center align-items-center"
              >
                <md-icon
                  v-if="passValid(pass)"
                  :md-src="$helpers.pass.getIcon(pass.type)"
                  class="icon-pass"
                  :class="$helpers.pass.getColor(pass.type)"
                />
              </div>
              <div
                class="col-9 col-sm-10 d-flex justify-content-content align-items-center"
              >
                <div>
                  <h4 class="mb-1">
                    {{ passValid(pass) ? pass.name : "No pass" }}
                  </h4>
                  <h6 :class="{ 'text-danger': pass.in_prepurchase }">
                    {{
                      passValid(pass)
                        ? pass.expires_at
                          ? "Expires: " +
                            $moment(pass.expires_at)
                              .subtract(1, "days")
                              .format("DD/MM/YYYY")
                          : "Renews 1st July"
                        : ""
                    }}
                  </h6>
                  <h6>Pass No.: {{ pass.card_number || "[not collected]" }}</h6>
                  <a
                    v-if="pass.in_prepurchase"
                    href="#"
                    class="text-danger"
                    @click.prevent="renew(pass)"
                    >Renew Now</a
                  >
                  <!-- <h6 class="mb-1">
                    {{
                      passValid(pass) ? "$" + centsToDollars(pass.price) : ""
                    }}
                  </h6> -->
                </div>
              </div>
              <hr style="color:#999;" />
            </div>
            <md-button class="md-primary" @click="renewSelf()"
              >Purchase a pass</md-button
            >
          </md-card-content>
        </md-card>
        <div v-if="user.permissions.includes('manage employees')">
          <md-card>
            <md-card-header data-background-color="secondary">
              <h4 class="title">Purchase Access Passes</h4>
              <p class="category">
                You can view and update your employee/other access passes here
              </p>
            </md-card-header>
            <md-card-content>
              <employee-pass-table
                ref="usersTable"
                @selected="updateSelected"
              />
              <md-button
                class="md-primary"
                :disabled="selectedUsers.length === 0"
                @click="renewSelected()"
              >
                Add Pass For Selected ({{ selectedUsers.length }})
              </md-button>
              <md-button class="md-secondary mx-2" @click="renewAll()">
                Add Passes For All
              </md-button>
            </md-card-content>
          </md-card>
          <md-card>
            <md-card-header data-background-color="secondary">
              <h4 class="title">Add New Employee</h4>
              <p class="category">
                Add employee/other accounts here
              </p>
            </md-card-header>
            <md-card-content>
              <registration-form-abbr @userAdded="updateUsersList()" />
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegistrationFormAbbr from "./Forms/RegistrationFormAbbr.vue";
import EmployeePassTable from "./Tables/employeePassTable.vue";
import { mapGetters } from "vuex";
import { centsToDollars } from "@/util";
import ApiService from "@/services/api";

export default {
  components: {
    RegistrationFormAbbr,
    EmployeePassTable
  },
  data() {
    return {
      selectedUsers: [],
      promptCancelSelected: false,
      passesToCancel: []
    };
  },
  computed: {
    user() {
      return this.$store.getters.authUser;
    },
    ...mapGetters(["passTypes"])
  },
  created() {
    this.$store.dispatch("getPassTypes");
  },
  methods: {
    passValid(pass) {
      return (
        !pass.expires_at ||
        this.$moment(pass.expires_at).isAfter(this.$moment())
      );
    },
    updateUsersList() {
      this.$refs.usersTable.updateTable();
    },
    updateSelected(items) {
      this.selectedUsers = items;
    },
    renewAll() {
      let users = this.$refs.usersTable.employees;

      this.$store.dispatch("clearCart").then(() => {
        this.$store.dispatch("addAllToCart", users).then(() => {
          this.$router.push("/cart");
        });
      });
    },
    renewSelf() {
      this.$store.dispatch("clearCart").then(() => {
        this.$store.dispatch("setCart", [this.user]).then(() => {
          this.$router.push("/cart");
        });
      });
    },
    renewSelected() {
      this.$store.dispatch("setCart", this.selectedUsers).then(() => {
        this.$router.push("/cart");
      });
    },
    cancelSelected() {
      let data = {
        passes: []
      };

      try {
        this.passesToCancel.forEach(id => {
          data.passes.push({ id: id });
        });
      } catch (e) {
        this.$toast.error("One or more selected users do not have passes.");
        return;
      }

      ApiService.pass
        .cancelPasses(data)
        .then(() => {
          this.updateUsersList();
          this.promptCancelSelected = false;
          this.$toast.success("Passes cancelled successfully.");
        })
        .catch(() => {
          this.$toast.error("Failed to cancel selected passes!");
        });
    },
    centsToDollars,
    renew(pass) {
      this.$store.dispatch("setCart", [this.user]).then(() => {
        this.$router.push("/cart");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
